import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "./i18n";

// Import scss
import "./assets/scss/theme.scss";

import AppRoute from "./routes/route";
import PageNotFound from "./pages/Common/NotFound";
import ErrorBoundary from "./pages/Common/ErrorBoundary";

class App extends Component {
  getLayout = () => {
    switch (this.props.layout.layoutType) {
      case "horizontal":
        return HorizontalLayout;
      default:
        return VerticalLayout;
    }
  };

  render() {
    const Layout = this.getLayout();

    return (
      <React.Fragment>
        <ErrorBoundary>
          <Routes>
            {publicRoutes.map((route, idx) => (
              <Route
                key={idx}
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <Route
                key={idx}
                path={route.path}
                element={
                  <AppRoute>
                    <Layout>{route.component}</Layout>
                  </AppRoute>
                }
              />
            ))}

            {/* 404 Page */}
            <Route
              path="*"
              element={
                <NonAuthLayout>
                  <PageNotFound />
                </NonAuthLayout>
              }
            />
          </Routes>
        </ErrorBoundary>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

export default connect(mapStateToProps, null)(App);
